import React from 'react';
import classNames from 'classnames';

import { CoreLink } from '@uncinc/react-drupal-core';
import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import { WysiwygField } from '../../../components';

import './style.scss';

const CtaTeaser = ({ entity }) => {
  const classes = classNames('ArticleTeaser');
  let url = false;
  if (entity.getIn(['field_link'])) {
    url = entity.getIn(['field_link', 0, 'alias']) ? entity.getIn(['field_link', 0, 'alias']) : entity.getIn(['field_link', 0, 'uri']);
  }

  return (
    <article typeof="schema:WebPage" className={classes}>
      {url ? (
        <CoreLink to={url} className="overlapping-link" />
      ) : null}
      <div className="ArticleTeaser__content">
        {entity.getIn(['field_media_item', 0]) ? (
          <div className="ArticleTeaser__imageWrapper">
            <Image
              alt={entity.getIn(['field_media_item', 0, 'title'], '')}
              lazyload={false}
              src={entity.getIn(['field_media_item', 0, 'styles', 'teaser_large'], '')}
              className="ArticleTeaser__imageNormal"
            />
            <Image
              alt={entity.getIn(['field_media_item', 0, 'title'], '')}
              lazyload={false}
              src={entity.getIn(['field_media_item', 0, 'styles', 'large'], '')}
              className="ArticleTeaser__imageMobile"
            />
          </div>
        ) : null}
        <div className="ArticleTeaser__contentWrapper">
          {entity.getIn(['field_title', 0, 'value']) ? (
            <h3>{entity.getIn(['field_title', 0, 'value'])}</h3>
          ) : null}
          {entity.getIn(['field_text', 0, 'processed']) ? (
            <WysiwygField
              property="schema:text"
              className="node--page--body"
              html={entity.getIn(['field_text', 0, 'processed'], '')}
            />
          ) : null}
        </div>
      </div>
    </article>
  );
};

export default CtaTeaser;
